export class StringUtils {
    static localeCompare(a, b) {
        if (a == b) {
            return 0;
        }
        if (a == undefined) {
            return -1;
        }
        if (b == undefined) {
            return 1;
        }
        return a.localeCompare(b);
    }
    static removeLastChar(str) {
        return str.substr(0, -1);
    }
    static abbreviateInitials(text, max = 2) {
        let letters = "";
        for (let part of text.split(/\s+/)) {
            if (letters.length < max) {
                letters += part.charAt(0).toUpperCase();
            }
        }
        return letters;
    }
}
export class ArrayUtils {
    static shuffle(source) {
        const array = [...source];
        let currentIndex = array.length, temporaryValue, randomIndex;
        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;
            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }
        return array;
    }
    static hasItems(arr) {
        return arr && arr.length;
    }
    static splitIntoChunks(source, chunkSize) {
        const chunks = [];
        for (let i = 0; i < source.length; i += chunkSize) {
            chunks.push(source.slice(i, i + chunkSize));
        }
        return chunks;
    }
    static replace(source, matcher, replacement) {
        return source.map(value => matcher(value) ? replacement : value);
    }
}
export function NOP() {
    return void 0;
}
//# sourceMappingURL=utils.js.map